import { useCallback, useRef } from 'react';

type UseIntentProps = {
  timeout?: number;
  resetTimeout?: boolean;
};

// eslint-disable-next-line
export function useIntent<T extends (...args: any) => void>(
  callback: T,
  props: UseIntentProps = {}
) {
  const { resetTimeout, timeout = 3 * 1000 } = props;
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const clearCurrentTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const handler = useCallback(
    (...params: Parameters<T>) => {
      console.log('Intent triggered.');
      if (resetTimeout && timeoutRef.current) {
        console.log('Clearing existing timeout...');
        clearCurrentTimeout();
      }

      if (!timeoutRef.current) {
        console.log('Scheduling new intent...');
        timeoutRef.current = setTimeout(() => {
          console.log(`Executing intent with params ${JSON.stringify(params)}`);
          callback(...params);
        }, timeout);
      } else {
        console.log('Intent exists. Waiting for previous intent to complete.');
      }
    },
    [callback, timeout, resetTimeout]
  );

  return [handler, { cancel: clearCurrentTimeout }] as const;
}
